export const USER_FEEDBACK_MESSAGE_MAX_LENGTH = 2000;
